import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkUpdateProjectsRequest = { projects: '_maskedProject' };
var _bulkUpdateProjectsResponse = { results: '_bulkUpdateProjectsResult' };
var _bulkUpdateProjectsResult = { project: '_project' };
var _commonImage = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _createNewPortfolioAppRequest = {};
var _createNewPortfolioAppResponse = {};
var _createProjectRequest = { project: '_project' };
var _createProjectResponse = { project: '_project' };
var _deleteProjectRequest = {};
var _deleteProjectResponse = {};
var _getProjectPageDataRequest = {};
var _getProjectPageDataResponse = { project: '_project' };
var _getProjectRequest = {};
var _getProjectResponse = { project: '_project' };
var _image = {
    imageInfo: '_commonImage',
    focalPoint: '_point',
    unsharpMasking: '_unsharpMasking',
};
var _listProjectsRequest = {};
var _listProjectsResponse = { projects: '_project' };
var _maskedProject = {
    fieldMask: 'google.protobuf.FieldMask',
    project: '_project',
};
var _point = { x: 'DOUBLE', y: 'DOUBLE' };
var _project = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    coverImage: '_image',
    coverVideo: '_video',
    source: '_projectSource',
};
var _projectsInCollections = {
    sortOrder: 'google.protobuf.DoubleValue',
    project: '_project',
};
var _projectSource = { lastSync: 'google.protobuf.Timestamp' };
var _queryProjectsRequest = {};
var _queryProjectsResponse = { projects: '_project' };
var _queryProjectWithCollectionInfoRequest = {};
var _queryProjectWithCollectionInfoResponse = {
    projects: '_projectsInCollections',
};
var _restoreProjectFromTrashBinRequest = {};
var _restoreProjectFromTrashBinResponse = { project: '_project' };
var _unsharpMasking = {
    amount: 'google.protobuf.FloatValue',
    radius: 'google.protobuf.FloatValue',
    threshold: 'google.protobuf.FloatValue',
};
var _updateProjectOrderInCollectionRequest = {
    sortOrder: 'google.protobuf.DoubleValue',
};
var _updateProjectOrderInCollectionResponse = {
    project: '_projectsInCollections',
    projectInCollection: '_projectsInCollections',
};
var _updateProjectRequest = {
    mask: 'google.protobuf.FieldMask',
    project: '_project',
};
var _updateProjectResponse = { project: '_project' };
var _video = { videoInfo: '_videoV2' };
var _videoResolution = { poster: '_commonImage' };
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_commonImage',
};
function resolveComWixpressPortfolioProjectsProjectsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/projects-service',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/projects-service',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/projects-service',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/projects-service',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/projects-service',
                destPath: '/api',
            },
            {
                srcPath: '/portfolio/projects/projects/api/v1/bulk/portfolio/projects',
                destPath: '/api/v1/bulk/portfolio/projects',
            },
            {
                srcPath: '/portfolio/projects/projects/api/1/portfolio/projects',
                destPath: '/api/1/portfolio/projects',
            },
        ],
        _: [
            {
                srcPath: '/_api/projects-service',
                destPath: '/api',
            },
            {
                srcPath: '/portfolio/projects/projects/api/v1/bulk/portfolio/projects',
                destPath: '/api/v1/bulk/portfolio/projects',
            },
            {
                srcPath: '/portfolio/projects/projects/api/1/portfolio/projects',
                destPath: '/api/1/portfolio/projects',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/projects-service',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/portfolio/v1/projects',
                destPath: '/api/v1/portfolio/projects',
            },
            {
                srcPath: '/portfolio/projects/projects/api/v1/bulk/portfolio/projects',
                destPath: '/api/v1/bulk/portfolio/projects',
            },
            {
                srcPath: '/portfolio/projects/projects/api/v1/portfolio/projects',
                destPath: '/api/v1/portfolio/projects',
            },
            {
                srcPath: '/portfolio/projects/projects/api/1/portfolio/projects',
                destPath: '/api/1/portfolio/projects',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/projects-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressPortfolioPortfolioappPortfolioAppServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/_api/portfolio-app-service',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/portfolio/v1/settings',
                destPath: '/api/v1/portfolio/settings',
            },
            {
                srcPath: '/portfolio/portfolio-app/api/v1/portfolio/settings',
                destPath: '/api/v1/portfolio/settings',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/portfolio/project/items/media',
                destPath: '/api/v1/portfolio/project/items/media',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/portfolio/portfolio-app/api/v1/portfolio/settings',
                destPath: '/api/v1/portfolio/settings',
            },
            {
                srcPath: '/portfolio/project-items/api/v1/portfolio/project/items/media',
                destPath: '/api/v1/portfolio/project/items/media',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get project data for a specific project */
export function getProjectPageData(payload) {
    var _a = serializer(_getProjectPageDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProjectPageDataResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getProjectPageData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'GET',
            methodFqn: 'com.wixpress.portfolio.portfolioapp.PortfolioAppService.GetProjectPageData',
            url: resolveComWixpressPortfolioPortfolioappPortfolioAppServiceUrl({
                protoPath: '/api/v1/portfolio/{collectionSlug}/projects/{projectSlug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProjectPageData.fromReq = fromReq;
    __getProjectPageData.__isAmbassador = true;
    return __getProjectPageData;
}
/** create default Portfolio data */
export function createNewPortfolioApp(payload) {
    var _a = serializer(_createNewPortfolioAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createNewPortfolioAppResponse, {}).fromJSON;
    function __createNewPortfolioApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.portfolioapp.PortfolioAppService.CreateNewPortfolioApp',
            url: resolveComWixpressPortfolioPortfolioappPortfolioAppServiceUrl({
                protoPath: '/api/v1/portfolio',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createNewPortfolioApp.fromReq = fromReq;
    __createNewPortfolioApp.__isAmbassador = true;
    return __createNewPortfolioApp;
}
/** Creates a project. */
export function createProject(payload) {
    var _a = serializer(_createProjectRequest, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createProjectResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.CreateProject',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/portfolio/projects',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createProject.fromReq = fromReq;
    __createProject.__isAmbassador = true;
    return __createProject;
}
/** Retrieves a project. */
export function getProject(payload) {
    var _a = serializer(_getProjectRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProjectResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'GET',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.GetProject',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/portfolio/projects/{projectId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProject.fromReq = fromReq;
    __getProject.__isAmbassador = true;
    return __getProject;
}
/** Retrieves a list of all projects in a portfolio. */
export function listProjects(payload) {
    var _a = serializer(_listProjectsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listProjectsResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listProjects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'GET',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.ListProjects',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/portfolio/projects',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listProjects.fromReq = fromReq;
    __listProjects.__isAmbassador = true;
    return __listProjects;
}
/** Updates a project. */
export function updateProject(payload) {
    var _a = serializer(_updateProjectRequest, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateProjectResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'PATCH',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.UpdateProject',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/portfolio/projects/{project.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProject.fromReq = fromReq;
    __updateProject.__isAmbassador = true;
    return __updateProject;
}
/** Updates multiple projects. */
export function bulkUpdateProjects(payload) {
    var _a = serializer(_bulkUpdateProjectsRequest, {
        _commonImage: _commonImage,
        _image: _image,
        _maskedProject: _maskedProject,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateProjectsResponse, {
        _bulkUpdateProjectsResult: _bulkUpdateProjectsResult,
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkUpdateProjects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'PATCH',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.BulkUpdateProjects',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/bulk/portfolio/projects/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateProjects.fromReq = fromReq;
    __bulkUpdateProjects.__isAmbassador = true;
    return __bulkUpdateProjects;
}
/** Deletes a project. */
export function deleteProject(payload) {
    var _a = serializer(_deleteProjectRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteProjectResponse, {}).fromJSON;
    function __deleteProject(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'DELETE',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.DeleteProject',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/portfolio/projects/{projectId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteProject.fromReq = fromReq;
    __deleteProject.__isAmbassador = true;
    return __deleteProject;
}
/**
 * Retrieves a list of projects, given the provided paging, filtering, and sorting. Up to 100 projects can be returned per request.
 *
 * The default `sort` is `id` in `ASC`.
 *
 * For a detailed list of supported operations, see [Projects: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/portfolio/projects/sort-and-filter).
 * To learn how to query projects, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 */
export function queryProjects(payload) {
    var _a = serializer(_queryProjectsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProjectsResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryProjects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.QueryProjects',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/portfolio/projects/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryProjects.fromReq = fromReq;
    __queryProjects.__isAmbassador = true;
    return __queryProjects;
}
/**
 * Deprecated - please use ProjectsInCollectionsService.UpdateProjectOrderInCollection instead
 * our Client still use it
 * @deprecated
 */
export function updateProjectOrderInCollection(payload) {
    var _a = serializer(_updateProjectOrderInCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateProjectOrderInCollectionResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _projectsInCollections: _projectsInCollections,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateProjectOrderInCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'PATCH',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.UpdateProjectOrderInCollection',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/portfolio/projects/{projectId}/collections/{collectionId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProjectOrderInCollection.fromReq = fromReq;
    __updateProjectOrderInCollection.__isAmbassador = true;
    return __updateProjectOrderInCollection;
}
/**
 * Deprecated - please use ProjectsInCollectionsService.QueryProjectsInCollections instead
 * our Client still use it
 * @deprecated
 */
export function queryProjectsWithCollectionInfo(payload) {
    var _a = serializer(_queryProjectWithCollectionInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProjectWithCollectionInfoResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _projectsInCollections: _projectsInCollections,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryProjectsWithCollectionInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.QueryProjectsWithCollectionInfo',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/1/portfolio/projects/collections/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryProjectsWithCollectionInfo.fromReq = fromReq;
    __queryProjectsWithCollectionInfo.__isAmbassador = true;
    return __queryProjectsWithCollectionInfo;
}
/** Restore from trash bin a project that was deleted. Will lead to restoring Project's items as well. */
export function restoreProjectFromTrashBin(payload) {
    var _a = serializer(_restoreProjectFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreProjectFromTrashBinResponse, {
        _commonImage: _commonImage,
        _image: _image,
        _point: _point,
        _project: _project,
        _projectSource: _projectSource,
        _unsharpMasking: _unsharpMasking,
        _video: _video,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __restoreProjectFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.portfolio.projects.v1.project',
            method: 'POST',
            methodFqn: 'com.wixpress.portfolio.projects.ProjectsService.RestoreProjectFromTrashBin',
            url: resolveComWixpressPortfolioProjectsProjectsServiceUrl({
                protoPath: '/api/v1/portfolio/trash-bin/projects/{projectId}/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreProjectFromTrashBin.fromReq = fromReq;
    __restoreProjectFromTrashBin.__isAmbassador = true;
    return __restoreProjectFromTrashBin;
}
//# sourceMappingURL=http.impl.js.map